export type FacetedFilterValueItem = {
  key: string;
  value: string[];
};

export const areFacetedFilterValuesEqual = (
  arrA: FacetedFilterValueItem[],
  arrB: FacetedFilterValueItem[]
): boolean => {
  if (arrA.length !== arrB.length) return false;
  if (arrA.length === 0 && arrB.length === 0) return true;

  // For a more robust comparison, sort both arrays by key first,
  // then sort the 'value' arrays within each object.
  const sortInnerArray = (arr: string[]) => [...arr].sort();
  const normalizeAndSort = (arr: FacetedFilterValueItem[]) =>
    [...arr]
      .map((item) => ({ ...item, value: sortInnerArray(item.value) }))
      .sort((a, b) => a.key.localeCompare(b.key));

  const normalizedA = normalizeAndSort(arrA);
  const normalizedB = normalizeAndSort(arrB);

  for (let i = 0; i < normalizedA.length; i++) {
    if (normalizedA[i].key !== normalizedB[i].key) return false;
    if (normalizedA[i].value.length !== normalizedB[i].value.length)
      return false;
    // Deep compare sorted value arrays
    for (let j = 0; j < normalizedA[i].value.length; j++) {
      if (normalizedA[i].value[j] !== normalizedB[i].value[j]) return false;
    }
  }
  return true;
};

export const areStringArraysEqual = (
  arrA: string[],
  arrB: string[]
): boolean => {
  if (arrA.length !== arrB.length) return false;
  if (arrA.length === 0 && arrB.length === 0) return true;
  const sortedA = [...arrA].sort();
  const sortedB = [...arrB].sort();
  for (let i = 0; i < sortedA.length; i++) {
    if (sortedA[i] !== sortedB[i]) return false;
  }
  return true;
};
